export default () => '/nope';
